<template>
  <div class="col-12 px-0">
    <NewsletterType
      :draft="draft"
      :newsletter-types="newsletterTypes"
      @clearedDraft="onClearedDraft"
    />

    <h2 class="text-black mb-3 mr-2">Featured Overview <small class="text-muted">(optional)</small></h2>

    <form-control
      class="mb-3"
      v-model="draft.steps.overview.title"
      :errors="highlightFields && !draft.steps.overview.title ? [' '] : []"
      :no-margin="true"
      placeholder="Enter featured overview title"
      title="Featured Overview Title"
      @input="update('title')"
    />

    <div class="form-group border-bottom pb-5 mb-4">
      <label>Featured Overview Synopsis</label>
      <HtmlEditor
        v-model="draft.steps.overview.synopsis"
        :class="{
          'is-invalid':
            highlightFields &&
            (!draft.steps.overview.synopsis ||
              draft.steps.overview.synopsis === ' ')
        }"
        :token="`Bearer ${$login.getToken()}`"
        :image-upload-url="imageUploadUrl"
        :file-upload-url="fileUploadUrl"
      />
    </div>

    <h2 class="text-black mb-3 mr-2">Spotlight</h2>
    <ArticlesFields
      :customArticleLabel="'Spotlight Article'"
      :customSynopsisLabel="'Spotlight Synopsis'"
      :customTitleLabel="'Spotlight Title'"
      :customImageUploadLabel="`From the Analysts's Desk Image Upload`"
      ref="article-field"
      v-model="synopsisArticleFields"
      class="pt-3 border-bottom pb-4 mb-4"
      :highlight-fields="highlightFields"
      withImage
      @input="onSynopsisArticleUpdate"
    />

    <form-control
      class="mb-4 pb-4"
      v-model="draft.steps.overview.analyst_image_title"
      :errors="error ? error.errors.analyst_image_title : []"
      :no-margin="true"
      title="From the Analyts's Desk Image Title"
      placeholder="Enter image title"
      @input="update('analyst_image_title')"
    />
  </div>
</template>

<script>
import { HtmlEditor, FileUpload } from '@frontend/components'
import AutocompleteArticle from '@/components/AutocompleteArticle'
import NewsletterType from '../Components/NewsletterType'
import ArticlesFields from '../ArticlesFields.vue'

export default {
  name: 'WeeklyRoundUpOverviewStep',

  components: {
    AutocompleteArticle,
    NewsletterType,
    FileUpload,
    HtmlEditor,
    ArticlesFields,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterTypes: {
      type: Array,
      required: true,
    },
    highlightFields: {
      required: true,
      type: Boolean,
    },
  },

  metaInfo() {
    return {
      title:
        this.draft && this.draft.subject
          ? this.draft.subject
          : 'Create Newsletter'
    }
  },

  data() {
    const pictures = []
    // eslint-disable-next-line camelcase
    const { analyst_image } = this.draft.steps.overview

    // eslint-disable-next-line camelcase
    if (analyst_image) {
      // eslint-disable-next-line camelcase
      pictures[0] = analyst_image
    }

    return {
      pictures,
      newsletterType: this.newsletterTypes.find(
        (t) => t.id === this.draft.newsletter_type_id
      ),
      error: null,
      url: process.env.VUE_APP_API_ENDPOINT,
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file',
      synopsisArticleFields: {
        article: this.draft.steps.overview.analyst_article,
        title: this.draft.steps.overview.analyst_title,
        synopsis: this.draft.steps.overview.analyst_synopsis,
        image: this.draft.steps.overview.analyst_image
      }
    }
  },

  watch: {
    newsletterType(value) {
      this.draft.newsletter_type_id = value.id
    }
  },

  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$login.getToken()
      }
    }
  },

  methods: {
    onSynopsisArticleUpdate(data) {
      const { article, synopsis, title, image } = data
      let mappedArticle = null

      if (article) {
        const { id, slug, analyst } = article
        mappedArticle = {
          id,
          slug,
          analyst,
          title: article.title
        }
      }

      this.$emit('update', {
        steps: {
          overview: {
            article,
            analyst_article: mappedArticle,
            analyst_title: title,
            analyst_synopsis: synopsis,
            ...(image ? { analyst_image: image } : null)
          }
        }
      })
    },

    update(key = '') {
      this.$emit('update', {
        steps: {
          overview: {
            [key]: this.draft.steps.overview[key]
          }
        }
      })
    },
    onClearedDraft(newDraft) {
      this.$emit('clearedDraft', newDraft)
    }
  }
}
</script>
